"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var _moment = _interopRequireDefault(require("moment"));
var _getAppDate = _interopRequireDefault(require("../get-app-date"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var momentise = function momentise(time) {
  return (0, _moment["default"])(time, _moment["default"].ISO_8601, true);
};
var startOfTime = momentise('1900-01-01T00:00:00+11:00');
var endOfTime = momentise('2999-01-01T00:00:00+11:00');
var convertRanges = function convertRanges(ranges) {
  return (0, _fp.map)(function (range) {
    return {
      end: range.end ? momentise(range.end) : endOfTime,
      start: range.start ? momentise(range.start) : startOfTime
    };
  }, ranges);
};
var isFeatureEnabled = function isFeatureEnabled(config, featureName) {
  var prefix = "features:".concat(featureName);
  var enabled = config.get("".concat(prefix, ":enabled"));
  var enabledAt = config.get("".concat(prefix, ":enabledAt"));
  var disabledAt = config.get("".concat(prefix, ":disabledAt"));
  var enabledRanges = config.get("".concat(prefix, ":enabledRanges"));
  if (!(0, _fp.isUndefined)(enabled)) {
    return enabled;
  }
  if ((0, _fp.every)(_fp.isUndefined, [enabledAt, disabledAt, enabledRanges])) {
    return false;
  }
  var appDate = (0, _getAppDate["default"])(config);
  var appDateMoment = (0, _moment["default"])(appDate);
  var ranges = convertRanges(enabledRanges || [{
    end: disabledAt,
    start: enabledAt
  }]);
  return (0, _fp.some)(function (range) {
    return appDateMoment.isBetween(range.start, range.end);
  }, ranges);
};
var _default = exports["default"] = isFeatureEnabled;
module.exports = exports.default;